import React, { Fragment, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Drawer, Divider, Paper, Button, Typography, TextField, InputAdornment, IconButton } from '@material-ui/core';
import { Hidden } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import { Context } from 'context';
import useRouter from 'utils/useRouter';
import { Navigation, Label, Header } from 'components';
import navigation, { admin, Sales, CS, Writer, Blaztap, Finance, SalesMobile, Partner, Partner2, SalesOfficer, SalesManager, Marketing, MarketingManager, dev } from '../../../constants/navigation';
import GlobalStyles from 'constants/style';
import packageJson from '../../../../package.json';

import UrlServer from 'constants/urlserver';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.navbar,
    height: '100%',
    width: '240px',
    minWidth: '240px'
  },
  content: {
    padding: theme.spacing(1)
  },
  brand: {
    padding: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(2)
  },
  searchContainer: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  searchInput: {
    background: 'rgba(255, 255, 255, 0.08)',
    borderRadius: '4px',
    '& .MuiInputBase-input': {
      color: '#ffffff',
    },
    '& .MuiOutlinedInput-root': {
      color: '#ffffff',
      '& fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.2)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.4)',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.6)',
      },
    },
    '& .MuiInputAdornment-root': {
      color: 'rgba(255, 255, 255, 0.5)',
    },
    '& .MuiIconButton-root': {
      color: 'rgba(255, 255, 255, 0.5)',
      padding: 4,
    }
  }
}));

const NavBar = props => {
  const { lastSync, openMobile, onMobileClose, handlingSinkron, handleRestartAPI, className, ...rest } = props;

  const globalClasses = GlobalStyles()
  const classes = useStyles();
  const router = useRouter();
  const [last, setLast] = useState('')
  const [akses, setAkses] = useState([]);
  const [data, setDataLogin] = useState([]);
  const [dt, setData] = useState('');
  const [dtaksesvip, setDataAksesVIP] = useState('');
  const [state, dispatch] = React.useContext(Context);
  const [searchQuery, setSearchQuery] = useState('');

  const getFilteredNavigation = (list, query) => {
    if (!query) return list;
    const lowerQuery = query.toLowerCase();
    return list.map(category => {
      const filteredPages = category.pages.reduce((acc, page) => {
        const pageMatches = page.title.toLowerCase().includes(lowerQuery);
        let matchedChildren = null;
        if (page.children) {
          matchedChildren = page.children.filter(child => 
            child.title.toLowerCase().includes(lowerQuery)
          );
        }
        if (pageMatches || (matchedChildren && matchedChildren.length > 0)) {
          acc.push({
            ...page,
            children: pageMatches ? page.children : matchedChildren
          });
        }
        return acc;
      }, []);
      return {
        ...category,
        pages: filteredPages
      };
    }).filter(category => category.pages.length > 0);
  };

  useEffect(() => {
    if (openMobile) {
      onMobileClose && onMobileClose();
    }
    const dtlog = JSON.parse(localStorage.getItem('datalog'));
    dtlog && setAkses(dtlog.hak_akses);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.location.pathname]);

  useEffect(() => {
    setLast(lastSync)
    fetchData()
  }, [])

  async function fetchData() {
    const dtlog = JSON.parse(localStorage.getItem('datalog'));
    console.log("data id login api", dtlog)

    if (dtlog && dtlog.id_relasi !== null) { // biar api saldo partner tidak di get terus
      const res = await fetch(UrlServer.backendapi + 'saldo/' + (dtlog.hak_akses == 'Sales' ? 'sales/' : 'partner/') + dtlog.id_relasi, {
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': 'sjgyfne73592643gedudney3628465hgrdt',
        },
      });
      res.json().then(res => {
        const list = res.result

        setData(list[0])
        // console.log("data saldo",list[0])
      })

      if (dtlog.hak_akses == 'Partner') {
        const ress = await fetch(UrlServer.backendapi + 'partner/' + dtlog.id_relasi, {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': 'sjgyfne73592643gedudney3628465hgrdt',
          },
        });
        ress.json().then(res => {
          const list = res.result
          // console.log('sss', list)
          setDataAksesVIP(list[0].akses_vip)
        })
      }
    } else {
      setData('')
      setDataAksesVIP('')
    }
  }

  const navbarContent = (
    <div className={classes.content}>
      <div className={classes.brand}>
        <RouterLink to="/">
          <div className={globalClasses.flexColumn}>
            <img
              alt="Logo"
              src="/images/brand/logobilas3.png"
            />
            <Label color="orange" className={globalClasses.margin_l_10}>v{packageJson.version}</Label>
          </div>
        </RouterLink>

        <Divider className={classes.divider} />
      </div>
      {akses == 'Sales' || akses == 'Partner' ?
        <div className={classes.brand}>
          {/* <Header title="Saldo Saya" /> */}
          {/* <h3>Saldo Saya</h3> */}
          <h2 align='center' style={{ color: 'white' }}>Saldo : {dt.saldo ? dt.saldo : '0'},-</h2>
          <Divider className={classes.divider} />
        </div> : ''}

      <div className={classes.searchContainer}>
        <TextField
          className={classes.searchInput}
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          placeholder="Cari Menu..."
          variant="outlined"
          size="small"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: searchQuery && (
              <InputAdornment position="end">
                <IconButton
                  aria-label="clear search"
                  onClick={() => setSearchQuery('')}
                  edge="end"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </div>
      {akses == "SuperAdmin" ?
        <nav>
          {getFilteredNavigation(navigation, searchQuery).map(list => (
            <Navigation
              component="div"
              key={list.title}
              pages={list.pages}
              title={list.title}
            />
          ))}
        </nav> : akses == "Admin" ?
          <nav>
            {getFilteredNavigation(admin, searchQuery).map(list => (
              <Navigation
                component="div"
                key={list.title}
                pages={list.pages}
                title={list.title}
              />
            ))}
          </nav> : akses == "CS" ?
            <nav>
              {getFilteredNavigation(CS, searchQuery).map(list => (
                <Navigation
                  component="div"
                  key={list.title}
                  pages={list.pages}
                  title={list.title}
                />
              ))}
            </nav> : akses == "SalesOfficer" ?
              <nav>
                {getFilteredNavigation(SalesOfficer, searchQuery).map(list => (
                  <Navigation
                    component="div"
                    key={list.title}
                    pages={list.pages}
                    title={list.title}
                  />
                ))}
              </nav>
              : akses == "SalesManager" ?
                <nav>
                  {getFilteredNavigation(SalesManager, searchQuery).map(list => (
                    <Navigation
                      component="div"
                      key={list.title}
                      pages={list.pages}
                      title={list.title}
                    />
                  ))}
                </nav>
                : akses == "Writer" ?
                  <nav>
                    {getFilteredNavigation(Writer, searchQuery).map(list => (
                      <Navigation
                        component="div"
                        key={list.title}
                        pages={list.pages}
                        title={list.title}
                      />
                    ))}
                  </nav>
                  : akses == "Marketing" ?
                    <nav>
                      {getFilteredNavigation(Marketing, searchQuery).map(list => (
                        <Navigation
                          component="div"
                          key={list.title}
                          pages={list.pages}
                          title={list.title}
                        />
                      ))}
                    </nav>
                    : akses == "MarketingManager" ?
                      <nav>
                        {getFilteredNavigation(MarketingManager, searchQuery).map(list => (
                          <Navigation
                            component="div"
                            key={list.title}
                            pages={list.pages}
                            title={list.title}
                          />
                        ))}
                      </nav>
                      : akses == "Blaztap" ?
                        <nav>
                          {getFilteredNavigation(Blaztap, searchQuery).map(list => (
                            <Navigation
                              component="div"
                              key={list.title}
                              pages={list.pages}
                              title={list.title}
                            />
                          ))}
                        </nav> :
                        akses == "Finance" ?
                          <nav>
                            {getFilteredNavigation(Finance, searchQuery).map(list => (
                              <Navigation
                                component="div"
                                key={list.title}
                                pages={list.pages}
                                title={list.title}
                              />
                            ))}
                          </nav> :
                          akses == "dev" ?
                            <nav>
                              {getFilteredNavigation(dev, searchQuery).map(list => (
                                <Navigation
                                  component="div"
                                  key={list.title}
                                  pages={list.pages}
                                  title={list.title}
                                />
                              ))}
                            </nav> :
                            akses == "Partner" ?
                              (dtaksesvip ?
                                <nav>
                                  {getFilteredNavigation(Partner, searchQuery).map(list => (
                                    <Navigation
                                      component="div"
                                      key={list.title}
                                      pages={list.pages}
                                      title={list.title}
                                    />
                                  ))}
                                </nav> :
                                <nav>
                                  {getFilteredNavigation(Partner2, searchQuery).map(list => (
                                    <Navigation
                                      component="div"
                                      key={list.title}
                                      pages={list.pages}
                                      title={list.title}
                                    />
                                  ))}
                                </nav>)
                              :
                              <div>
                                <Hidden mdDown>
                                  <nav>
                                    {getFilteredNavigation(Sales, searchQuery).map(list => (
                                      <Navigation
                                        component="div"
                                        key={list.title}
                                        pages={list.pages}
                                        title={list.title}
                                      />
                                    ))}
                                  </nav>
                                </Hidden>
                                <Hidden lgUp>
                                  <nav>
                                    {getFilteredNavigation(SalesMobile, searchQuery).map(list => (
                                      <Navigation
                                        component="div"
                                        key={list.title}
                                        pages={list.pages}
                                        title={list.title}
                                      />
                                    ))}
                                  </nav>
                                </Hidden>
                              </div>
      }
    </div>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          <div
            {...rest}
            className={clsx(classes.root, globalClasses.flexContainer, globalClasses.flexColumn)}
          >
            <PerfectScrollbar>
              <div className={globalClasses.flexOne}>
                {navbarContent}
              </div>
            </PerfectScrollbar>
            {/* <Divider /> */}
          </div>
        </Drawer>
      </Hidden>
      <Hidden mdDown>

        <Paper
          {...rest}
          className={clsx(classes.root, globalClasses.flexContainer, globalClasses.flexColumn)}
          elevation={0}
          square
        >
          <PerfectScrollbar>
            <div className={globalClasses.flexOne}>
              {navbarContent}
            </div>
          </PerfectScrollbar>
          {/* <Divider /> */}
        </Paper>

      </Hidden>
    </Fragment>
  );
};

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  handlingSinkron: PropTypes.func,
  handleRestartAPI: PropTypes.func
};

export default NavBar;
